import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import SelectFundingEditFlow from './SelectFundingEditFlow';

import { getApplication } from '../../store/actions/application/applicationActions';
import IraFundAccountSelect from '../FundAccountSelect/IraFundAccountSelect';
import FundRetirementAmountForm from '../Forms/FundRetirementAmountForm';
import Custodian from '../Custodian/Custodian';
import CustodianAccountNumber from '../Custodian/CustodianAccountNumber';
import CustodianTransferType from '../Custodian/CustodianTransferType';
import CustodianIraType from '../Custodian/CustodianIraType';
import CustodianReview from '../Custodian/CustodianReview';
import useApplicationUid from '../../hooks/useApplicationUid';
import Modal from '../Modal';
import StepByStep from '../StepByStep/StepByStep';

const steps = [
  SelectFundingEditFlow,
  IraFundAccountSelect,
  FundRetirementAmountForm,
  Custodian,
  CustodianAccountNumber,
  CustodianTransferType,
  CustodianIraType,
  FundRetirementAmountForm,
  CustodianReview,
];

const IraFundModal = ({ isOpen, onClose }) => {
  const [modalSize, setModalSize] = useState('md');
  const [editFundFlow, setEditFundFlow] = useState('');
  const { ApplicationUid } = useApplicationUid();
  const dispatch = useDispatch();
  const [isManual, setIsManual] = useState(false);
  const [shouldClearForm, setShouldClearForm] = useState(false);

  useEffect(() => {
    setEditFundFlow('');
  }, []);

  return (
    <Modal variant={modalSize} isOpen={isOpen} onClose={onClose}>
      <StepByStep saveStepDisabled>
        {({
          goStepForward,
          goStepBack,
          skipPreviousStep,
          skipNextStep,
          goToStepsBack,
        }) =>
          steps.map((step) =>
            React.createElement(step, {
              handleBack: goStepBack,
              handleNext: () => {
                dispatch(getApplication({ data: { ApplicationUid } }));
                goStepForward();
              },
              skipPreviousStep,
              skipNextStep,
              setModalSize,
              setEditFundFlow,
              onModalClose: () => {
                dispatch(
                  getApplication({
                    data: { ApplicationUid },
                    onSuccess: () => {
                      onClose();
                    },
                  }),
                );
              },
              editFundFlow,
              goToStepsBack,
              isManual,
              setIsManual,
              setShouldClearForm,
              shouldClearForm,
              onSkip: onClose,
            }),
          )
        }
      </StepByStep>
    </Modal>
  );
};

IraFundModal.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default IraFundModal;
